// @flow

import * as React from 'react';
import {InputCommand} from '../terminal/command';

export class Executable {
  command: InputCommand;

  commands: {};

  setAllowInput: (boolean) => void;

  constructor(command: InputCommand, setAllowInput: (boolean) => void) {
    this.command = command;
    this.commands = {};
    this.setAllowInput = setAllowInput;
  }

  commandName() {
    return '';
  }

  shortHelp() {
    return this.help();
  }

  help() {
    throw new Error('implement help');
  }

  run(apiKey: string): React.Node {
    throw new Error('implement run');
  }
}
